export const SYSTEM_TAGS_PATH = '/shareBizConfigs/systemTags';

export const SYSTEM_TAG_LANGUAGES = [
  { id: 'en', labelKey: 'bizAdminLangEnglish' },
  { id: 'ar', labelKey: 'bizAdminLangArabic' },
  { id: 'heb', labelKey: 'bizAdminLangHebrew' },
  { id: 'ru', labelKey: 'bizAdminLangRussian' },
];

export const SYSTEM_TAG_ID_PATTERN = /^[A-Za-z][A-Za-z0-9_-]{0,63}$/;

export const getTagLabel = (tag, language = 'en') => {
  if (!tag) return '';
  const localized = tag.localizedName;
  if (localized && typeof localized === 'object') {
    return (
      localized[language] ||
      localized.en ||
      localized.heb ||
      localized.ar ||
      localized.ru ||
      Object.values(localized).find((value) => typeof value === 'string' && value.trim()) ||
      tag.label ||
      tag.value ||
      ''
    );
  }
  return tag.label || tag.value || '';
};

export const canAssignTag = (tag) => {
  if (!tag?.isSystemTag) return true;
  return tag.isAssignable === true;
};

export const canUnassignTag = (tag) => {
  if (!tag?.isSystemTag) return true;
  return tag.isUnassignable === true;
};

export const isValidSystemTagId = (id) => SYSTEM_TAG_ID_PATTERN.test(String(id || '').trim());

export const mapSystemTag = (id, data = {}) => ({
  value: id,
  label: getTagLabel({ localizedName: data.localizedName, label: data.name }, 'en'),
  color: data.color || '#618264',
  isHidden: data.isHidden === true,
  isEditable: false,
  isSystemTag: true,
  isAssignable: data.isAssignable === true,
  isUnassignable: data.isUnassignable === true,
  localizedName: data.localizedName || {},
  createdTimestamp: data.createdTimestamp || null,
});

export const buildSystemTagPayload = ({
  color,
  isHidden,
  isAssignable,
  isUnassignable,
  localizedName,
  createdTimestamp,
}) => ({
  color,
  createdTimestamp,
  isHidden: isHidden === true,
  isSystemTag: true,
  isAssignable: isAssignable === true,
  isUnassignable: isUnassignable === true,
  localizedName,
});
